import { useLocation } from 'react-router-dom';

function ScrollToTopButton() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/admin');

  // Don't show the button on admin pages
  if (isAdminPage) {
    return null;
  }

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="flex justify-center my-4 cursor-pointer">
      <img
        src="/images/alltop.png"
        alt="Scroll to top"
        onClick={handleScrollToTop}
        className="hover:opacity-80 transition-opacity"
      />
    </div>
  );
}

export default ScrollToTopButton;
